<template>
  <h1 v-if="isFirst" v-bind="attrs" v-html="nbsp(content)" />
  <h2 v-else v-bind="attrs" v-html="nbsp(content)" />
</template>

<script setup lang="ts">
defineProps<{
  content: string
  isFirst?: boolean
}>()

const attrs = useAttrs()
</script>
